/**
 * ATH / Now values for ReferenceLines, drawn in the left margin of the chart
 * (beside the Y axis ticks) so they never sit on top of the data. Charts using
 * them need MARKER_CHART_MARGIN for the room.
 *
 *   <LineChart margin={MARKER_CHART_MARGIN}>
 *     <ReferenceLine y={ath} label={markerLabel(`ATH ${ath}`, '#ef4444', 'above')} />
 *     <ReferenceLine y={cur} label={markerLabel(`Now ${cur}`, '#22c55e', 'below')} />
 */

export const MARKER_CHART_MARGIN = { top: 12, right: 5, bottom: 5, left: 44 };

/** `above` / `below` the line's height: ATH above and Now below can't collide,
 *  since Now is never higher than ATH. */
export function markerLabel(value: string, fill: string, place: 'above' | 'below') {
  return ({ viewBox }: { viewBox?: { y?: number } }) => {
    const y = viewBox?.y ?? 0;
    return (
      <text x={4} y={place === 'above' ? Math.max(y - 3, 10) : y + 11} fill={fill} fontSize={10} fontWeight={600}>
        {value}
      </text>
    );
  };
}
